import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'dt-legal-notes',
  templateUrl: './legal-notes.component.html',
  styleUrls: ['./legal-notes.component.scss'],
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegalNotesComponent {}
